import { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setOrgLogoImage } from "../../actions/organizations-actions";

import { Box, Flex, Image, } from "@chakra-ui/react";
import { validateUrlFormat } from '../../../global/helpers/global-helpers';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import PageLoader from '../../../global/components/helper-components/components/PageLoader';
import DefaultSpinner from '../../../global/components/helper-components/components/DefaultSpinner';

import '../../../digital-sales-room/styles/dsr-display.scss';
import '../../../digital-sales-room/styles/dsr-invite-display.scss';
import '../../../global/styles/custom-animations.scss'
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';


function OrganizationLogoByUrl({ currentOrgLogo, imageIsSaving, setOrgLogoImage }) {
  const [uriInput, setUriInput] = useState("")
  const [feedUriInput, setFeedUriInput] = useState("")

  // UX management
  const [showlogoLoader, setShowlogoLoader] = useState(true)
  const [currentLogoImage, setCurrentLogoImage] = useState(currentOrgLogo ? currentOrgLogo : "")
  const [showLogoImage, setShowLogoImage] = useState(false)
  const [showInvalidUrlError, setShowInvalidUrlError] = useState(false)
  const [showImageError, setShowImageError] = useState(false)
  const [showButtons, setShowButtons] = useState(false)
  const [showChangeLogoButton, setShowChangeLogoButton] = useState(true)

  const [showLogoInput, setShowLogoInput] = useState(false)


  const handleImageError = () => {
    setShowLogoImage(false)
    setShowImageError(true)
    setShowlogoLoader(false)
  }

  const handleInputChange = (event) => {
    setUriInput(event.target.value)
  }

  const handlePressEnter = (event) => {
    if (event.key === 'Enter' && event.target.name === "logo-search-input") {
      const isValidUrl = uriInput ? validateUrlFormat(uriInput) : false;
      setShowImageError(false)
      setCurrentLogoImage(false)

      if (isValidUrl && uriInput) {
        setFeedUriInput(uriInput)
        setShowLogoImage(true)
      } else {
        setShowInvalidUrlError(true)
      }

    }
  }

  const handleGetCbLogo = () => {
    setShowlogoLoader(true)
    const isValidUrl = uriInput ? validateUrlFormat(uriInput) : false;
    setShowImageError(false)
    setCurrentLogoImage(false)

    if (isValidUrl && uriInput) {
      setFeedUriInput(uriInput)
      setShowLogoImage(true)
      // setShowButtons(true)
      setShowInvalidUrlError(false)

    } else {
      setShowInvalidUrlError(true)
    }
  }

  const handleSetOrgLogo = () => {
    setOrgLogoImage(`https://logo.clearbit.com/${feedUriInput}`)
  }

  const displaySearchLogoModule = () => {
    return (
      <Box w='80%' my='1em'>
          <LaunchdeckFormInput
            label='Website URL'
            name={'logo-search-input'}
            onChange={handleInputChange}
            onPressEnter={handlePressEnter}
            placeholder={`E.g.: 'https://www.nike.com'`}
            value={uriInput}

            errorLogic={showInvalidUrlError}
            errorMessage={`No logo found`}
          />
        <Box fontSize='0.7em' textAlign='center' color={showInvalidUrlError ? 'brandPink.500' : 'gray.500'} my='0.5em' fontStyle='italic'>{`Tip: Works best with homepage url without any extensions \n Example: 'https://www.nike.com'`}</Box>
        <Flex mt='0.8em' align='center' justify='center'>
          <LaunchdeckButton name='userProviderUri' label='Find Logo' fontSize='0.8em' py='0.4em' bg='brandDark.500' color='gray.50' onClick={() => handleGetCbLogo()} />
        </Flex>
      </Box>
    )
  }

  const handleFindAnotherLogo = () => {
    setShowLogoInput(true)
    setShowlogoLoader(false)
    setShowChangeLogoButton(false)
    setShowButtons(false)
  }

  const displayAndEditLogoModule = () => {

    if (showLogoImage) {
      return (
        <>
          <Flex boxSize='128px' direction='column' mb='3em' justify='center' align='center' border='1px solid' borderColor='gray.100'>

            <Image 
            fallback={<PageLoader />}
            src={`https://logo.clearbit.com/${feedUriInput}`} onError={handleImageError} onLoad={handleImageFound} />

          </Flex>
          {showChangeLogoButton &&
            <LaunchdeckButton bg='gray.500' color='white' onClick={() => { setShowLogoInput(true); setShowChangeLogoButton(false) }} label='Change Logo' />
          }
        </>
      )
    } else if (!showImageError && !showLogoImage) {
      
      return (
        <>
          <Flex boxSize='128px' direction='column' mb='3em' rounded='0.5em' justify='center' align='center' border='1px solid' borderColor='gray.100'>
            {currentLogoImage ? <Image 
              fallback={<DefaultSpinner />}
              src={`${currentLogoImage}`} 
              onError={handleImageError} 
            /> :
            <Box fontSize='0.875em' color='gray.500'>
              No logo image
            </Box>
    }
          </Flex>
          {showChangeLogoButton &&
            <LaunchdeckButton bg='gray.500' color='white' onClick={() => { setShowLogoInput(true); setShowChangeLogoButton(false) }} label='Change Logo' />
          }
        </>
      )
    } else if (showImageError) {
      return (

        <>
          <Flex boxSize='128px' direction='column' mb='3em' justify='center' align='center' border='1px solid' borderColor='gray.100'>
            <Box display={showlogoLoader ? "block" : "none"}>
              <PageLoader />
            </Box>
            <Box>Can't find Logo</Box>
          </Flex>
          {showChangeLogoButton &&
            <LaunchdeckButton bg='gray.500' color='white' onClick={() => { setShowLogoInput(true); setShowChangeLogoButton(false) }} label='Change Logo' />
          }
        </>
      )
    } else return null;
  }


  const handleImageFound = () => {
    setShowLogoInput(false)
    setShowChangeLogoButton(false)
    setShowButtons(true)
    setShowlogoLoader(false)
  }



  return (
    <Flex direction='column' align='center' justify='center' w='100%' px='2em'>
      {imageIsSaving ? <PageLoader /> 
      :
      <>
        <Box>
          {displayAndEditLogoModule()}
        </Box>
  
        {showLogoInput && displaySearchLogoModule()}
  
        <Flex w='100%' py='0.625em'>
          <Flex justify='flex-end' w='100%'>
            {(showButtons && !showInvalidUrlError && !showImageError) &&
              <Flex w='100%' align='center' justify='center'>
                <LaunchdeckButton bg='gray.500' color='white' onClick={handleFindAnotherLogo} label='Find another logo' />
                <Box px='1em' />
                <LaunchdeckButton bg='brand.500' color='gray.50' onClick={handleSetOrgLogo} label='Use this logo' />
              </Flex>
            }
          </Flex>
        </Flex>
      </>
      }
    </Flex>
  )
  
 
}

function mapStateToProps(state) {
  return {
    imageIsSaving: state.setOrgLogo.isLoading,
    imageSaved: state.setOrgLogo.imageSet
  };
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setOrgLogoImage
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrganizationLogoByUrl));
